import { render, staticRenderFns } from "./sys.vue?vue&type=template&id=d21fd7d4&"
import script from "./sys.vue?vue&type=script&lang=js&"
export * from "./sys.vue?vue&type=script&lang=js&"
import style0 from "./sys.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports